import Model from './Model'

export default class ConstructionWorkerModel extends Model {
  id!: number
  firstname!: string
  lastname!: string
  address!: string
  denied!: {
    is_denied: boolean
    reason: string
    date: string
  }

  resource () : string {
    return 'constructionWorkers'
  }
}
